import { render, staticRenderFns } from "./research.vue?vue&type=template&id=ad298246&scoped=true"
import script from "./research.vue?vue&type=script&lang=js"
export * from "./research.vue?vue&type=script&lang=js"
import style0 from "./research.vue?vue&type=style&index=0&id=ad298246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad298246",
  null
  
)

export default component.exports